import { __ } from '@wordpress/i18n';
const { InnerBlocks } = wp.blockEditor;

export default ({ attributes, className }) => {
    return (
        <section className={ `Banner ${ className }` }>
            <div className="Banner-wrapper">
                <div className="Banner-content">
                    <img src={attributes.url} />
                    <InnerBlocks.Content />
                </div>
                <div className="Banner-image">
                </div>
            </div>
        </section>
    )
}